"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGridStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeGridStyles = function makeGridStyles(_ref) {
  var breakpoints = _ref.breakpoints,
      primitives = _ref.primitives,
      tokens = _ref.tokens;
  // Use grid token "margin" values for container padding
  var containerBreakpointStyles = Object.fromEntries(breakpoints.keys.map(function (breakpoint) {
    return [breakpoints.up(breakpoints.values[breakpoint]), {
      // Subtract left padding of first grid item from left padding of container
      // for consistent padding on either side of the container
      paddingLeft: "calc(".concat(tokens.grid[breakpoint].margin, " - ").concat(tokens.grid[breakpoint].gutter, ")"),
      paddingRight: tokens.grid[breakpoint].margin
    }];
  })); // Programatically add scoped item spacing using the "gutter" values of the grid tokens

  var itemBreakpointStyles = Object.fromEntries(breakpoints.keys.map(function (breakpoint) {
    return [breakpoints.up(breakpoints.values[breakpoint]), _defineProperty({}, "& [class*='MuiGrid-item']", {
      paddingLeft: tokens.grid[breakpoint].gutter,
      paddingTop: tokens.grid[breakpoint].gutter
    })];
  }));
  return {
    MuiGrid: {
      styleOverrides: {
        root: _objectSpread({
          "&[class*='MuiGrid-container']": _objectSpread(_objectSpread({}, containerBreakpointStyles), {}, {
            maxWidth: primitives.grid["max-width"]
          })
        }, itemBreakpointStyles)
      }
    },
    MuiGrid2: {
      defaultProps: {
        spacing: {
          xs: tokens.grid.xs.gutter,
          sm: tokens.grid.sm.gutter,
          md: tokens.grid.md.gutter,
          lg: tokens.grid.lg.gutter,
          xl: tokens.grid.xl.gutter
        }
      }
    }
  };
};

exports.makeGridStyles = makeGridStyles;